import { useEffect } from "react";

import { RETRY_COUNT } from "@impero-com/common/utils/query_client";
import * as Cookies from "es-cookie";

import { OrganizationDisplayInfo } from "api/generated/model";
import { useGetOrgDisplayInfoSuspense } from "api/generated/organization/organization";

function saveAsCookie(cookie: OrganizationDisplayInfo) {
    const encoded = encodeURIComponent(JSON.stringify(cookie));
    Cookies.set("organization", encoded, {
        sameSite: "lax",
        secure: true,
        path: "/",
    });
}

export function useOrgDisplayInfo() {
    const { data } = useGetOrgDisplayInfoSuspense({
        query: {
            select: ({ data }) => ({
                ...data,
                loginRightSideLogo: data.loginRightSideLogo ?? null,
                loginRightSideBackground: data.loginRightSideBackground ?? null,
            }),
            staleTime: Infinity,
            retry: RETRY_COUNT,
        },
    });

    // Save the `organization` cookie such that Legacy can read it
    useEffect(() => {
        saveAsCookie(data);
    }, [data]);

    return data;
}

export const mockDisplayInfo = {
    name: "test",
    shortName: "test",
    loginRightSideLogo: null,
    loginRightSideBackground: null,
    globalId: "eaee2259-bb30-4fbe-9e07-8e81b263df32",
    isActive: true,
} satisfies OrganizationDisplayInfo;
